import { Reveal, SectionHeading } from "./Reveal";

export const HowItWorks = () => (
    <section
        id="come-funziona"
        data-testid="how-it-works-section"
        className="py-24 sm:py-36 bg-charcoal border-y border-white/10"
    >
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHeading
                index="02"
                eyebrow="Come funziona"
                title="Quattro passi verso il tuo impianto."
                testId="how-it-works-heading"
            />

            <div className="mt-16 flex flex-col">
                {[
                    ["01", "Invia la panoramica", "Fotografa la tua panoramica dentale e inviala su WhatsApp. Bastano pochi minuti, direttamente dal tuo telefono."],
                    ["02", "Ricevi il preventivo", "Entro 24 ore ricevi un piano di trattamento dettagliato, con prezzi chiari e senza alcun impegno."],
                    ["03", "Volo e accoglienza", "Pensiamo a tutto noi: volo, hotel e transfer privato. Tu devi solo preparare le valigie."],
                    ["04", "Il tuo nuovo sorriso", "Trattamento con tecnologie di ultima generazione e follow-up in italiano anche dopo il rientro."],
                ].map(([n, title, text], i) => (
                    <Reveal key={n} delay={i * 0.06}>
                        <div
                            data-testid={`step-${n}`}
                            className="group relative flex flex-col sm:flex-row sm:items-baseline gap-4 sm:gap-12 py-10 sm:py-12 border-t border-white/10 last:border-b"
                        >
                            <span className="number-outline font-display text-7xl sm:text-8xl font-light leading-none shrink-0 group-hover:[-webkit-text-stroke-color:rgba(212,175,55,0.6)] transition-all duration-500">
                                {n}
                            </span>
                            <div>
                                <h3 className="font-display text-2xl sm:text-3xl text-white font-light">
                                    {title}
                                </h3>
                                <p className="mt-3 text-white/70 leading-relaxed max-w-xl">
                                    {text}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
